import { StyleSheet } from 'react-native';

export const globalStyles = StyleSheet.create({
  container: {
    marginHorizontal: 10,
  },
  profilePic: {
    height: 50,
    width: 50,
    borderRadius: 50 / 2,
  },
});
